import { Cosmograph } from "@cosmograph/react";
import { useContext } from "react";
import { GraphContext } from "./data";

export function CosmoComponentSimple() {
  const { setClusterData, setNodeData, sharedData, setSharedData } = useContext(GraphContext);
  const onClick = (d: any) => {
    setClusterData(undefined);
    // console.log("click", d);
    if (!d) {
      setSharedData({
        source: "",
        subType: sharedData.subType,
      });
      return;
    }

    setNodeData(d);
    if (d["cluster_no"] && d["cluster_no"] !== "0") {
      setSharedData({
        source: d["id"],
        subType: "",
      });
    }
  };

  const onLabelClick = (d: any) => {
    // console.log("label", d);
    onClick(d);
  };
  return (
    <Cosmograph
      nodeColor={(d: any) => d["nodecolor"]}
      nodeSize={(d: any) => d["nodesize"]}
      linkColor={(d: any) => d["linkcolor"]}
      // linkWidth={(d: any) => {
      //   const size = d["source"] === sharedData.source ? 2 : 1;
      //   return size;
      // }}
      disableSimulation={true}
      fitViewOnInit={true}
      // linkVisibilityDistanceRange={(d: any) => [d.alntmscore as number, 1000]}
      // spaceSize={4000}
      linkArrows={false}
      simulationGravity={0.25}
      simulationRepulsion={1}
      simulationRepulsionTheta={1.92}
      simulationLinkSpring={1}
      simulationLinkDistance={10}
      simulationFriction={0.5}
      simulationDecay={0}
      // simulationLinkSpring={0.5}
      // simulationCenter={4}
      // simulationRepulsionQuadtreeLevels={5}
      // showDynamicLabels={true}
      // renderLinks={true}
      onLabelClick={onLabelClick}
      onClick={onClick}
    />
  );
}
